import _defineProperty from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
import _classCallCheck from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/createClass";
import { __rest } from "tslib";
import { getSizeChannel, POSITION_SCALE_CHANNELS } from '../channel';
import { isFieldOrDatumDef } from '../channeldef';
import * as log from '../log';
import { isUnitSpec } from '../spec/unit';
import { keys } from '../util';
export var RangeStepNormalizer =
/*#__PURE__*/
function () {
  function RangeStepNormalizer() {
    _classCallCheck(this, RangeStepNormalizer);

    this.name = 'RangeStep';
  }

  _createClass(RangeStepNormalizer, [{
    key: "hasMatchingType",
    value: function hasMatchingType(spec) {
      var _a;

      if (isUnitSpec(spec) && spec.encoding) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = POSITION_SCALE_CHANNELS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var channel = _step.value;
            var def = spec.encoding[channel];

            if (def && isFieldOrDatumDef(def)) {
              if ((_a = def === null || def === void 0 ? void 0 : def.scale) === null || _a === void 0 ? void 0 : _a['rangeStep']) {
                return true;
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
              _iterator["return"]();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      return false;
    }
  }, {
    key: "run",
    value: function run(spec) {
      var _a;

      var sizeMixins = {};
      var encoding = Object.assign({}, spec.encoding);
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = POSITION_SCALE_CHANNELS[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var channel = _step2.value;
          var sizeType = getSizeChannel(channel);
          var def = encoding[channel];

          if (def && isFieldOrDatumDef(def)) {
            if ((_a = def === null || def === void 0 ? void 0 : def.scale) === null || _a === void 0 ? void 0 : _a['rangeStep']) {
              var scale = def.scale,
                  defWithoutScale = __rest(def, ["scale"]);

              var _b = scale,
                  rangeStep = _b.rangeStep,
                  scaleWithoutRangeStep = __rest(_b, ["rangeStep"]);

              sizeMixins[sizeType] = {
                step: scale['rangeStep']
              };
              log.warn(log.message.RANGE_STEP_DEPRECATED);
              encoding = Object.assign(Object.assign({}, encoding), _defineProperty({}, channel, Object.assign(Object.assign({}, defWithoutScale), keys(scaleWithoutRangeStep).length > 0 ? {
                scale: scaleWithoutRangeStep
              } : {})));
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
            _iterator2["return"]();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return Object.assign(Object.assign(Object.assign({}, sizeMixins), spec), {
        encoding: encoding
      });
    }
  }]);

  return RangeStepNormalizer;
}();